import React from 'react'
import { scaleLinear } from 'd3-scale'
interface props {
  answers: { [key: string]: [number, number] }
  user: string
  correct: string
  max: number
}

function getContrastYIQ(rgbString?: string) {
  if (!rgbString) return ''
  let rgb = rgbString
    .replace('rgb(', '')
    .replace(')', '')
    .split(', ')
    .map(Number)
  var r = rgb[0]
  var g = rgb[1]
  var b = rgb[2]
  var yiq = (r * 299 + g * 587 + b * 114) / 1000
  return yiq >= 150 ? 'var(--brand-blue-1)' : 'var(--beige-bright-2)'
}
export const TileMap = ({ answers, user, correct, max }: props) => {
  if (!answers) return null
  const tW = 130
  const color = scaleLinear<string, number>()
    .domain([0, max])
    .range(['#fff', '#202346'])

  let tiles = [
    { id: 'JU', pos: [tW * 1.5, tW], type: 'rect' },
    { id: 'NE', pos: [tW * 1.5, tW * 2], type: 'rect' },
    { id: 'FR', pos: [tW * 1.5, tW * 3], type: 'rect' },
    { id: 'VD', pos: [tW * 0.5, tW * 3], type: 'rect' },
    { id: 'GE', pos: [0, tW * 4], type: 'rect' },
    { id: 'SO', pos: [tW * 2.5, tW * 2], type: 'rect' },
    { id: 'BE', pos: [tW * 2.5, tW * 3], type: 'rect' },
    { id: 'VS', pos: [tW * 2, tW * 4], type: 'rect' },
    { id: 'AG', pos: [tW * 3.5, tW], type: 'rect' },
    { id: 'LU', pos: [tW * 3.5, tW * 2], type: 'rect' },
    { id: 'SH', pos: [tW * 4.5, 0], type: 'rect' },
    { id: 'ZH', pos: [tW * 4.5, tW * 1], type: 'rect' },
    { id: 'ZG', pos: [tW * 4.5, tW * 2], type: 'rect' },
    { id: 'SZ', pos: [tW * 4.5, tW * 3], type: 'rect' },
    { id: 'UR', pos: [tW * 4.5, tW * 4], type: 'rect' },
    { id: 'TI', pos: [tW * 4.5, tW * 5], type: 'rect' },
    { id: 'TG', pos: [tW * 5.5, tW], type: 'rect' },
    { id: 'SG', pos: [tW * 5.5, tW * 2], type: 'rect' },
    { id: 'GL', pos: [tW * 5.5, tW * 3], type: 'rect' },
    { id: 'GR', pos: [tW * 6.5, tW * 3], type: 'rect' },
    { id: 'BS', pos: [tW * 2.5, tW], type: 'triangle_top' },
    {
      id: 'BL',
      pos: [tW * 2.5, tW],
      type: 'triangle_bottom'
    },
    { id: 'OW', pos: [tW * 3.5, tW * 3], type: 'triangle_top' },
    {
      id: 'NW',
      pos: [tW * 3.5, tW * 3],
      type: 'triangle_bottom'
    },
    { id: 'AR', pos: [tW * 6.5, tW * 1.5], type: 'triangle_top' },
    {
      id: 'AI',
      pos: [tW * 6.5, tW * 1.5],
      type: 'triangle_bottom'
    }
  ]
  return (
    <svg viewBox={'-10 -50 ' + tW * 7.8 + ' ' + tW * 7} className='map'>
      <defs>
        <linearGradient
          spreadMethod='pad'
          id='gradient'
          x1='0%'
          y1='0%'
          x2='100%'
          y2='0%'
        >
          <stop
            offset='0%'
            style={{ stopColor: 'rgb(255, 255, 255)', stopOpacity: 1 }}
          />
          <stop
            offset='100%'
            style={{ stopColor: 'rgb(32, 35, 70)', stopOpacity: 1 }}
          />
        </linearGradient>
      </defs>
      <text x={0} y={30} className='yLabel'>
        Anteil an allen Antworten in %
      </text>
      <rect
        className='key'
        width='300'
        height='20'
        y='50'
        x='30'
        fill='url(#gradient)'
      />
      <text x={0} y={70} className='yLabel'>
        0
      </text>
      <text x={350} y={70} className='yLabel'>
        {Math.round(max)}
      </text>
      {tiles
        .sort((a, b) => {
          if (a.id === user || a.id === correct) return 1
          return -1
        })
        .map((tile, i) => {
          let answerTile = answers[tile.id]

          let col = (answerTile
            ? color(answers[tile.id][1])
            : color(0)
          )?.toString()

          let textCol = getContrastYIQ(col)
          let label = answerTile ? +answers[tile.id][1].toFixed(0) : 0

          let renderSwitch = (param: string, id: string) => {
            switch (param) {
              case 'rect':
                let x = tW * 0.5
                return (
                  <React.Fragment key={i}>
                    <rect width='130' height='130' style={{ fill: col }} />
                    <text
                      className='label'
                      y={tW * 0.7}
                      textAnchor='middle'
                      style={{ fill: textCol }}
                    >
                      <tspan x={tW * 0.5}>{label}</tspan>{' '}
                      <tspan className='percent' dx={1}>
                        %
                      </tspan>
                      <tspan className='id' dy={-32} x={x}>
                        {id}
                      </tspan>
                    </text>
                    {tile.id === user && (
                      <image
                        href={require('../../_assets/icons_user.png')}
                        y={-44}
                        x={-4}
                        width={44}
                      />
                    )}
                    {tile.id === correct && (
                      <image
                        href={require('../../_assets/icons_correct.png')}
                        y={-44}
                        x={-4}
                        width={44}
                      />
                    )}
                  </React.Fragment>
                )
              case 'triangle_top':
                x = tW * 0.05
                return (
                  <React.Fragment key={i}>
                    <polygon
                      points={'0,0 ' + tW + ',0 ' + '0,' + tW}
                      style={{ fill: col }}
                    />
                    <text
                      className='label'
                      y={tW * 0.5}
                      textAnchor='start'
                      style={{ fill: textCol }}
                    >
                      <tspan x={x}>{label}</tspan>
                      <tspan className='percent' dx={1}>
                        %
                      </tspan>
                      <tspan className='id' dy={-32} x={x}>
                        {id}
                      </tspan>
                    </text>
                    {tile.id === user && (
                      <image
                        href={require('../../_assets/icons_user.png')}
                        y={-44}
                        x={-4}
                        width={44}
                      />
                    )}
                    {tile.id === correct && (
                      <image
                        href={require('../../_assets/icons_correct.png')}
                        y={-44}
                        x={-4}
                        width={44}
                      />
                    )}
                  </React.Fragment>
                )
              case 'triangle_bottom':
                x = tW * 0.92
                return (
                  <React.Fragment key={i}>
                    <polygon
                      points={'0,' + tW + ' ' + tW + ',' + tW + ' ' + tW + ',0'}
                      style={{ fill: col }}
                    />
                    <text
                      className='label'
                      y={tW * 0.9}
                      textAnchor='end'
                      style={{ fill: textCol }}
                    >
                      <tspan x={x}>{label}</tspan>
                      <tspan className='percent' dx={1}>
                        %
                      </tspan>
                      <tspan className='id' dy={-32} x={x}>
                        {id}
                      </tspan>
                    </text>
                    {tile.id === user && (
                      <image
                        href={require('../../_assets/icons_user.png')}
                        y={tW}
                        x={tW - 40}
                        width={44}
                      />
                    )}
                    {tile.id === correct && (
                      <image
                        href={require('../../_assets/icons_correct.png')}
                        y={tW}
                        x={tW - 40}
                        width={44}
                      />
                    )}
                  </React.Fragment>
                )
            }
          }
          return (
            <g
              className={
                tile.id === correct ? 'correct' : tile.id === user ? 'user' : ''
              }
              transform={'translate(' + tile.pos[0] + ',' + tile.pos[1] + ')'}
              key={i}
            >
              {renderSwitch(tile.type, tile.id)}
            </g>
          )
        })}
    </svg>
  )
}
